import { type CSSToken, token } from '@atlaskit/tokens';

// skill border/accent colors that map to a color enum defined in integration service
// https://bitbucket.org/atlassian/integrations-service/src/5ebc708689a91d0dc8c35bc8dda1395c19fadb9a/integrations-service-skills-domain/src/main/kotlin/io/atlassian/skills/schema/SkillMetadata.kt#lines-7
// TODO: move to a skills types/integration service package
export type SkillColor =
	| 'LIME'
	| 'RED'
	| 'ORANGE'
	| 'YELLOW'
	| 'GREEN'
	| 'TEAL'
	| 'BLUE'
	| 'PURPLE'
	| 'MAGENTA'
	| 'GRAY'
	| 'DEFAULT';

type SkillColorMap = Record<SkillColor, { default: CSSToken; inverse?: CSSToken }>;

// mapping of skill color enum to ADS color tokens. Use inverse colors for dark backgrounds
export const SKILL_COLOR_MAP: SkillColorMap = {
	LIME: {
		default: token('color.border.accent.lime'),
	},
	RED: {
		default: token('color.border.accent.red'),
	},
	ORANGE: {
		default: token('color.border.accent.orange'),
	},
	YELLOW: {
		default: token('color.border.accent.yellow'),
	},
	GREEN: {
		default: token('color.border.accent.green'),
	},
	TEAL: {
		default: token('color.border.accent.teal'),
	},
	BLUE: {
		default: token('color.border.accent.blue'),
	},
	PURPLE: {
		default: token('color.border.accent.purple'),
	},
	MAGENTA: {
		default: token('color.border.accent.magenta'),
	},
	GRAY: {
		default: token('color.border.accent.gray'),
	},
	DEFAULT: {
		default: token('color.border'),
		inverse: token('color.border.inverse'),
	},
};
